import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { useForm } from 'react-hook-form';
import CustomizedGrid from '../../../../components/base/Grid/CustomizedGrid';
import Pagination from '../../../../components/base/Pagination/Pagination';
import { intlShape } from '../../../../components/base/IntlProviderWrapper';
import { Icons } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  getFilterData, getPaginationOpts, responseLogWithNotification, useUpdatePeriod,
} from '../../../../utils/utils';
import { REGION_REGISTRY_MODULE } from '../../../../configs/moduleNames';
import { getSystemData } from '../../../System/reducer';
import FilterRow from '../../../../components/base/FilterRow/FilterRow';
import FieldDTO from '../../../../components/fields/Abstract/FieldDTO';
import TextInput from '../../../../components/fields/TextInput/TextInput';

import { POPUP_LIST_NAME } from '../../../../configs';
import { addGlobalPopUpWrapper } from '../../../InformationScreenWrapper/actions';
import getDefaultSort from '../../../../utils/getDefaultSort';
import TimerLoader from '../../../../components/base/Loader/TimerLoader';
import { getRegisterData } from '../../../RegionRegistry/reducer';
import { loadCarrierList } from '../../../RegionRegistry/actions';
import { carrierColumns } from '../../../RegionRegistry/components/carrierColumns';
import TextSearchInput from '../../../../components/fields/TextInput/TextSearchInput';

export function CarrierBox(props) {
  const { onClose = () => {}, driver_id } = props;
  const dispatch = useDispatch();
  const {
    loadingCarrierList,
    carrierList = [],
    carrierListMeta,
  } = useSelector(getRegisterData);
  const store = useStore();
  const {
    formatMessage,
  } = intlShape;
  const rowClassFormatter = item => {
    const classes = ['clickable-table-row'];
    return classes.join(' ');
  };
  const loadData = opts => {
    const paginationOpts = getPaginationOpts(store.getState()[REGION_REGISTRY_MODULE].carrierListMeta, opts);
    const requestData = {
      sort,
      ...paginationOpts,
      filter: {
        driver_id,
        ...getValues(),
      },
    };
    const p1 = dispatch(loadCarrierList(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };
  const {
    getValues, control, watch, setValue, reset,
  } = useForm({ defaultValues: getFilterData('carrier-filter', {}) });
  const { updatePeriod } = useSelector(getSystemData);
  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);

  useEffect(() => {
    const subscription = watch(values => {
      localStorage.setItem('carrier-filter', JSON.stringify(values));
      loadData({ page: 1 });
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const moreFormatter = (_, item) => (
    <Icons customIcon icon="more-vert" className="more-vert" />
  );

  const [sort, setSort] = useState(getDefaultSort(carrierColumns));

  const changeSort = fieldName => {
    if (sort && (sort === fieldName || sort === `-${fieldName}`)) {
      if (sort === `-${fieldName}`) {
        setSort(fieldName);
      } else if (sort === fieldName) {
        setSort('');
      }
    } else {
      setSort(`-${fieldName}`);
    }
  };

  useEffect(() => { loadData(); }, [sort]);

  return (
    <div className="dlc-body flex-column">
      <TimerLoader loading={loadingCarrierList} />
      <div className="dlc-title">
        <Icons width={24} height={24} customIcon icon="arrow-return" onClick={onClose} />
        <div className="f3">{formatMessage({ id: 'driver.card.menu.carrier' })}</div>
        <FilterRow>
          <FieldDTO
            control={control}
            component={TextSearchInput}
            dtoObject={{
              name: 'search',
              type: String,
              labelKey: 'search',
            }}
          />
        </FilterRow>
      </div>
      <div className="grid-wrapper frame">
        <div className="custom-scroll-theme sticky-table-wrapper custom">
          <CustomizedGrid
            data={carrierList}
            columns={carrierColumns}
            onDoubleClickByRow={item => {
              dispatch((addGlobalPopUpWrapper({ window: POPUP_LIST_NAME.CARRIER_DETAIL, id: item.id })));
            }}
            additionalColumns={[]}
            name="carrier-list"
            changeSort={changeSort}
            sort={sort}
            rowClassFormatter={rowClassFormatter}
            settingsFormatter={moreFormatter}
          />
        </div>
        <Pagination meta={carrierListMeta} list={carrierList} handleChangeMeta={loadData} />
      </div>
    </div>
  );
}
